import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Square: IconNode = [
  'svg',
  defaultAttributes,
  [['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2' }]],
];

export default Square;
